import React from 'react';
import { i18n } from 'config/locales';
import ValidationElement from 'components/Form/ValidationElement';
import RadioGroup from 'components/Form/RadioGroup';
import Radio from 'components/Form/Radio';
import { ValidationElementProps } from 'components/Form/ValidationElement/ValidationElement';
import { ForeignTravelItemModel } from 'forms/sections/foreign/travel/types';
import { CommonOnError, CommonOnUpdate, CommonRequired } from 'types/props';

interface Props extends Partial<ForeignTravelItemModel['Days']>, ValidationElementProps {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  required?: CommonRequired
  className?: string
  attribute?: string
}

export default class TravelDays extends ValidationElement<Props> {
  update = (values: ForeignTravelItemModel['Days']) => this.props.onUpdate?.({ value: values.value });

  render() {
    const selected = this.props.value;
    return (
      <RadioGroup
        className={`travel-days option-list option-list-vertical ${
          this.props.className || ''
        }`.trim()}
        onError={this.props.onError}
        required={this.props.required}
        selectedValue={selected}
        attribute={this.props.attribute}
      >
        <Radio
          name="days-1-5"
          label={i18n.t('foreign.travel.label.one')}
          value="1-5"
          className="days-1-5"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Radio
          name="days-6-10"
          label={i18n.t('foreign.travel.label.six')}
          value="6-10"
          className="days-6-10"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Radio
          name="days-11-20"
          label={i18n.t('foreign.travel.label.eleven')}
          value="11-20"
          className="days-11-20"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Radio
          name="days-21-30"
          label={i18n.t('foreign.travel.label.twentyone')}
          value="21-30"
          className="days-21-30"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Radio
          name="more-than-30"
          label={i18n.t('foreign.travel.label.more')}
          value="More than 30"
          className="more-than-30"
          onUpdate={this.update}
          onError={this.props.onError}
        />
        <Radio
          name="many-short-trips"
          label={i18n.t('foreign.travel.label.many')}
          value="Many short trips"
          className="many-short-trips"
          onUpdate={this.update}
          onError={this.props.onError}
        />
      </RadioGroup>
    );
  }
}

TravelDays.defaultProps = {
  value: '',
  onError: (value, arr) => arr,
};
